import React, { useState, useEffect, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { validateToken, callApi } from "../../../lib/utils";
import moment, { duration } from "moment";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faChartSimple,
} from "@fortawesome/free-solid-svg-icons";
import GenericModal from "../../GenericComponents/GenericModal/GenericModal";
import { Chart } from "react-google-charts";
import TaskNotes from "../../GenericComponents/TaskNotes";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { unionBy } from "lodash";
import PulseLoader from "react-spinners/PulseLoader";
import TableFilterBar from "../../GenericComponents/TableFilterBar";


const AbnormalMotionReportList = ({params}) => {
  const [amEventsList, setAmeventsList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showGraphModal, setShowGraphModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [graphMomdalData, setGraphModalData] = useState({});
  const profileData = useSelector((state) => state?.dashboard);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [notesModalData, setNotesModalData] = useState({});
  const [loading,setLoading]=useState(false);
  const [pages, setPages] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  
  const changePage = (currentPage) => {
    setCurrentPage(currentPage);
  };
  const actionPerPage = (perPageCount) => {
    setCurrentPage(1);
    setPerPage(parseInt(perPageCount));
  };

  useEffect(() => {
    if (profileData?.profileData?.id) {
      actionPerPage(20);
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        fetchData();
      });
    }
  }, [params]);

  useEffect(() => {
    if (profileData?.profileData?.id) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        fetchData();
      });
    }
  }, [perPage, currentPage, params]);
  const dateFormatter = (cell, row) => {
    return `${moment(row.eventTimestamp).format("MMM-DD")}   ${moment(
      row.eventTimestamp
    ).format("hh:mm A")}`;
  };
  const classificationFormatter = (cell, row) => {
    // if (row?.isFalseAlarmEvent === null && row?.isTestEvent === null)
    //   return <span> Not Classified</span>;
    // else if (row?.isFalseAlarmEvent) return <span> Not An Actual Event</span>;
    // else if (row?.isFalseAlarmEvent === null && row?.isTestEvent === true)
    //   return <span> Test Event</span>;
    // else return <span> Actual Event</span>;
    if (row?.eventClassifiedAs === null)
      return <span> Not Classified</span>;
    else if (row?.eventClassifiedAs === 'N') 
      return <span> Not An Actual Event</span>;
    else if (row?.eventClassifiedAs === 'T')
      return <span> Test Event</span>;
    else return <span> Actual Event</span>;
  };
  
  const srNumberFormatter = (cell, row, rowIndex) => {
    if (currentPage > 1)
      return <>{perPage * (currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };
  const locationFormatter = (cell, row) => {
    return (
      (!!profileData?.appModules?.active?.GPS?.length && !profileData?.appModules?.inactive?.GPS?.length && row?.address)?
      <OverlayTrigger
        placement="right"
        overlay={
          <Popover
      id="popover-location"
      placement="right"
      bsClass="popover-location"
      // positionLeft={200}
      // positionTop={50}
    >
           {row?.address}
    </Popover>
        }
        trigger='click'
      >
        <label className="location-content" title={row?.address}>
          {row?.address}
          {/* <FontAwesomeIcon icon={faLocationDot} style={{ cursor: "pointer" }} /> */}
        </label>
      </OverlayTrigger>:"-"
    );
  };
  const graphFormatter = (cell, row) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="button-tooltip-location">
            Click To View Event Graph
          </Tooltip>
        }
      >
        <div className="graph-content">
          <FontAwesomeIcon icon={faChartSimple} style={{ cursor: "pointer" }} />
        </div>
      </OverlayTrigger>
    );
  };
  const heartRateFormatter = (cell, row) => {
    return (
      <table style={{ width: "100%" }}>
        <tr>
          <td>{row?.minHr ? row?.minHr : "-"}</td>
          <td>{row?.maxHr ? row?.maxHr : "-"}</td>
          <td>{row?.avgHr ? row?.avgHr : "-"}</td>
        </tr>
      </table>
    );
  };
  const heartRateHeaderFormatter = (column, colIndex) => {
    return (
      <table className="table-header">
        <tr className="table-header-heading">
          <td colSpan={3}>Heart Rate</td>
        </tr>
        <tr className="table-header-subheading">
          <td>Min</td>
          <td>Max</td>
          <td>Avg</td>
        </tr>
      </table>
    );
  };
  const handleShowModal = (show, data) => {
    if (show) {
      setModalData(data);
    } else {
      setModalData({});
    }
    setShowModal(show);
  };

  const handleShowGraphModal = (show, data) => {
    if (show) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        callApi(
          `/api/patient/events/abnormal-motion/sensor-data/${data.id}`,
          {},
          "GET"
        )
          .then((response) => {
            setGraphModalData(response?.data?.data);
          })
          .catch((err) => {
            console.log("err: ", err);
          });
      });
    } else {
      setGraphModalData({});
    }
    setShowGraphModal(show);
  };
  const severityHeaderFormatter = (coloumn, colIndex) => {
    return (
      <table className="table-header">
        <tr className="table-header-heading">
          <td colSpan={2}>SEVERITY</td>
        </tr>
        <tr className="table-header-subheading">
          <td>Amplitude</td>
          <td>Frequency</td>
        </tr>
      </table>
    );
  };
  const severityFormatter = (cell, row) => {
    return (
      <table style={{ width: "100%" }}>
        <tr>
          <td className="severity-values">{row?.severityByAmplitude ? row?.severityByAmplitude : "-"}</td>
          <td className="severity-values">{row?.severityByFrequency ? row?.severityByFrequency : "-"}</td>
        </tr>
      </table>
    );
  };
  const getAudioPlayerFormatter = (cell, row) => {
    return row?.isAudioFileDeleted === "N" ? (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="button-tooltip-audio-recording">
            Click To Play Audio Recording
          </Tooltip>
        }
      >
        <div style={{ cursor: "pointer" }}>
          <audio
            style={{
              maxWidth: "150px",
              opacity: row?.isAudioFileDeleted === "N" ? "1" : "0.5",
              cursor: "pointer",
            }}
            controls
            name="media"
          >
            <source
              src={
                row?.isAudioFileDeleted === "N"
                  ? `/upload/patient/web/abnormal-motion/audio/${row?.id}`
                  : ""
              }
              type="audio/mp3"
            />
          </audio>
        </div>
      </OverlayTrigger>
    ) : (
      <div style={{ cursor: "pointer" }}>
        <audio
          style={{
            maxWidth: "150px",
            opacity: row?.isAudioFileDeleted === "N" ? "1" : "0.5",
            cursor: "pointer",
          }}
          controls
          name="media"
        >
          <source
            src={
              row?.isAudioFileDeleted === "N"
                ? `/upload/patient/web/abnormal-motion/audio/${row?.id}`
                : ""
            }
            type="audio/mp3"
          />
        </audio>
      </div>
    );
  };
  const notesFormatter = (cell, row) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="button-tooltip-3">Click To View Notes</Tooltip>}
      >
        <img
          src="/images/pharmacy_workspace/notes_black_icn@2x.png"
          alt=""
          className="iconStyle"
          style={{ cursor: "pointer" }}
        />
      </OverlayTrigger>
    );
  };
  const durationFormatter = (cell, row) => {
    return (
      <span>
      {!!row?.totalEventDuration && ((Math.floor(row?.totalEventDuration / 60)) !== 0) &&
      moment({
        hour: 0,
        minute: row.totalEventDuration / 60,
        seconds: row.totalEventDuration % 60,
        milliseconds: 0,
      }).format("mm")}
    {!!((Math.floor(row?.totalEventDuration / 60)) !== 0) && <>{" "}min{" "}</>}
    {!!row?.totalEventDuration &&
      moment({
        hour: 0,
        minute: row.totalEventDuration / 60,
        seconds: row.totalEventDuration % 60,
        milliseconds: 0,
      }).format("ss")}{" "}
    secs
    </span>
    );
  };
  const handleShowNotesModal = (show, data) => {
    if (show) {
      setNotesModalData(data);
    } else {
      setNotesModalData({});
    }
    setShowNotesModal(show);
  };

  const columns = [
    {
      dataField: "id",
      text: "NO",
      formatter: srNumberFormatter,
      headerStyle: () => {
        return { width: "12px"};
      },
      
    },
    {
      dataField: "eventTimestamp",
      text: "EVENT DATE/TIME",
      formatter: dateFormatter,
      headerStyle: () => {
        return { width: "120px" };
      },
    },
    {
      dataField: "isFalseAlarmEvent",
      text: "CLASSIFICATION",
      headerStyle: () => {
        return { width: "120px" };
      },
      formatter: classificationFormatter,
      
    },
    {
      dataField: "totalEventDuration",
      text: "DURATION",
      formatter: durationFormatter,
      headerStyle: () => {
        return { width: "120px" };
      },
    },
    {
      dataField: "severity",
      text: "SEVERITY",
      headerFormatter: severityHeaderFormatter,
      formatter: severityFormatter,
      headerStyle: () => {
        return { width: "220px" };
      },
    },
    // {
    //   dataField: "eventGraph",
    //   text: "EVENT GRAPH",
    //   formatter: graphFormatter,
    //   headerStyle: () => {
    //     return { width: "164px" };
    //   },
    //   events: {
    //     onClick: (e, column, columnIndex, row, rowIndex) => {
    //       handleShowGraphModal(true, row);
    //     },
    //   },
    //   id: "graphButton",
    // },
    // {
    //   dataField: "notes",
    //   text: "NOTES",
    //   formatter: notesFormatter,
      
    //   headerStyle: () => {
    //     return { width: "120px" };
    //   },
    //   events: {
    //     onClick: (e, column, columnIndex, row, rowIndex) => {
    //       handleShowNotesModal(true, row);
    //     },
    //   },
    // },
    {
      dataField: "location",
      text: "LOCATION",
      formatter: locationFormatter,
      headerStyle: () => {
        return { width: "120px" };
      },
      // events: {
      //   onClick: (e, column, columnIndex, row, rowIndex) => {
      //     handleShowModal(true, row);
      //   },
      // },
      id: "locationButton",
    },
    // {
    //   dataField: "Audio Recording",
    //   text: "AUDIO RECORDING",
    //   formatter: getAudioPlayerFormatter,
    // },
    {
      dataField: "heartRate",
      //text: "<td>HEART RATE<td>",
      formatter: heartRateFormatter,
      headerFormatter: heartRateHeaderFormatter,
      headerStyle: () => {
        return { width: "320px" };
      },
    },
  ];
  const fetchData = () => {
    const payload = {...params, ...{page:currentPage, limit:perPage}}
    setLoading(true);
    callApi(`/api/reports/patient/event/abnormal-motion/list`, payload, "POST")
      .then((response) => {
        if (response?.data?.data?.abnormalMotionEvents) {
          setAmeventsList(response?.data?.data?.abnormalMotionEvents);
          setPages(!!response?.data?.data?.pagination?.pages?response?.data?.data?.pagination?.pages:0);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const MyMapComponent = ({ center, zoom }) => {
    const ref = useRef();

    useEffect(() => {
      new window.google.maps.Map(ref.current, {
        center,
        zoom,
      });
    });

    return (
      <div ref={ref} id="map1" style={{ height: "750px", width: "98%" }} />
    );
  };
  const mapStatus = (status) => {
    if (status === Status.FAILURE) return <div>Status: ${Status.FAILURE}</div>;
    //return <Spinner />;
  };

  const GoogleMap = (props) => {
    return (
      !!props.data?.latitude &&
      !!props.data?.longitude && (
        <Wrapper
          apiKey={"AIzaSyBZ-neHCssh_jPwQExqLW-KRfucDUaxIq8"}
          render={mapStatus}
        >
          <MyMapComponent
            center={{ lat: props.data?.latitude, lng: props.data?.longitude }}
            zoom={4}
          />
        </Wrapper>
      )
    );
  };
  const LineGraph = (props) => {
    const heartRate = props.graphData?.sensorData?.processedHrData?.filter((item, index) => item.y !== 0);
    const graphData =
    [...(props.graphData?.sensorData?.formattedData &&
    props.graphData?.sensorData?.formattedData?.length &&
    !!props.graphData?.sensorData?.formattedData
      ? props.graphData?.sensorData?.formattedData
      : heartRate?.length
      ? heartRate
      : [])];

      const result = unionBy(heartRate,graphData, 'x');
      
      const newData = result?.map((item, index) => {
        let temp = undefined;
        let sec = undefined;
        let isHeartRateValueExists = false;
        if (heartRate[index]?.y !== undefined) {
          temp = heartRate[index]?.y;
          sec = heartRate[index]?.x;
          isHeartRateValueExists = true;
        }
        if (sec === undefined) {
          sec = item.x;
        }
        if (temp === 0) {
          temp = undefined;
        }
        return !!heartRate?.length
          ? [sec, (item?.y && !isHeartRateValueExists) ? item?.y : 0, temp]
          : [sec, item?.y ? item?.y : 0];
      });
    
    const paramData = !!heartRate?.length?["Motion Monitoring", "Heart Rate"]:["Motion Monitoring"];
    const data = [
      [
        { type: "number", label: "Motion Monitoring Duration ( In Secs )" },
        ...paramData,
      ],
      ...newData,
    ];
    const options = {
      title: "Motion Monitoring Amplitude",
      width: "100%",
      height: 500,
      legend: "bottom",
      series: !!heartRate?.length
        ? {
            0: { targetAxisIndex: 0, type: "line", axis: "MotionMonitoring" },
            1: { targetAxisIndex: 1, type: "scatter", axis: "HeartRate" },
          }
        : {
            0: { targetAxisIndex: 0, type: "line", axis: "AbnormalMotion" },
          },
      axes: {
        y: !!heartRate?.length
          ? {
            MotionMonitoring: { label: "Motion Monitoring" },
              HeartRate: { label: "Heart Rate" },
            }
          : { MotionMonitoring: { label: "Motion Monitoring" } },
      },
      // vAxes: !!heartRate?.length
      //   ? {
      //       0: { title: "Abnormal Motion" },
      //       1: { title: "Heart Rate" },
      //     }
      //   : { 0: { title: "Abnormal Motion" } },
        vAxes:!!heartRate?.length?{    
          0: {title: 'Motion Monitoring' ,format:'0'},
          1: {title: 'Heart Rate',format:'0', minValue: heartRate[0].y-5, 
          maxValue: heartRate[heartRate?.length-1].y+5}}:{0: {title: 'Motion Monitoring'}},
      hAxis: {
        title: "Motion Monitoring Duration ( In Secs )",
      },
      colors: ["#5CB3FF", "#E42217"],
    };

    return (
      <div>{!newData?.length?(<div className="pulse-loader-container"><PulseLoader
      color={"#70757a"}
      loading={!!newData?.length}
      aria-label="Loading Spinner"
      data-testid="loader"
    /></div>):<Chart
    chartType="ComboChart"
    width="100%"
    height="100%"
    data={data}
    options={options}
    style={{ padding: "16px" }}
  />}
      </div>
    );
  };
  
  return (
    <>
        <TableFilterBar title="drilldown" perPage={perPage} pagination={{currentPage:currentPage, pages:pages}} changePage={changePage}
        actionPerPage={actionPerPage}/>
    <div>
      {loading?(<div className="pulse-loader-container"><PulseLoader
                  color={"#70757a"}
                  loading={loading}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                /></div>):
      <BootstrapTable
        keyField="id"
        data={amEventsList.sort((t1, t2) => {
          if (t1.eventTimestamp > t2.eventTimestamp) return -1;
          if (t1.eventTimestamp < t2.eventTimestamp) return 1;
          return 0;
        })}
        columns={columns}
        striped
        hover
        condensed
        bordered={false}
      />}
      <GenericModal
        key="map"
        showModal={showModal}
        handleShowModal={handleShowModal}
        ChildComponent={<GoogleMap data={modalData} />}
      />
      <GenericModal
        key="showgraph"
        showModal={showGraphModal}
        handleShowModal={handleShowGraphModal}
        ChildComponent={<LineGraph graphData={graphMomdalData}/>}
      />
      <GenericModal
        key="notes"
        showModal={showNotesModal}
        handleShowModal={handleShowNotesModal}
        ChildComponent={
          <TaskNotes
            data={notesModalData}
            payload={{
              patientId: notesModalData?.patientId,
              noteModuleId: 1,
              referenceId: notesModalData?.id,
              eventTypeId: parseInt(notesModalData?.eventType),
              patientTaskId:null,
            }}
            patientData={profileData?.profileData?.patientData}
          />
        }
        variant={"white"}
      />
    </div>
 </> );
};

export default AbnormalMotionReportList;
